import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { cleanupExpiredMetadataMappingStates } from '../reducers/metadataMappingReducer';

const useMetadataMappingCleanup = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(cleanupExpiredMetadataMappingStates());

    // Periodic cleanup every 1 minute
    const interval = setInterval(() => {
      dispatch(cleanupExpiredMetadataMappingStates());
    }, 1 * 60 * 1000);

    return () => clearInterval(interval);
  }, [dispatch]);
};

export default useMetadataMappingCleanup;
